import { apiRoutes } from "@constants/api-routes";
import { RequestTypes } from "@enums/request-types";
import { handleRequestWithQueryParamsAndBody } from "@utils/http-util";
import { VerificationServiceChangeRequestResponse } from "@idw-types/data/verification-service";
import { GenericNetworkResponse } from "@idw-types/generic-network-response";

export const createVerificationServiceRequest = async (
    rpServiceTemplateId: string,
    sourceRPServiceID: string,
    body: { [key: string]: any }
): Promise<GenericNetworkResponse<VerificationServiceChangeRequestResponse>> => {
    const route = apiRoutes.serviceConfiguration.rpServiceConfig.changeRequest.rpService.add;
    const queryParameters = [];
    if (rpServiceTemplateId) {
        queryParameters.push({
            parameter: "rpServiceTemplateID",
            value: rpServiceTemplateId
        });
    } else if (sourceRPServiceID) {
        queryParameters.push({
            parameter: "sourceRPServiceID",
            value: sourceRPServiceID
        });
    }

    const { data, error } = await handleRequestWithQueryParamsAndBody(RequestTypes.POST, route, queryParameters, body);
    return { data, error, queryParameters, body };
};